import { parseStringParam } from "/lib/util/params";
import { useRouter } from "/lib/component/util";

const useReqContext = () => {
  const router = useRouter();
  const routeParams = router.routeParams, routerLocation = router.routerLocation;
  const params = routeParams as any;
  const simpleUrl = !routerLocation.pathname.includes("~");

  return {
    namespace: parseStringParam(params.namespace, ""),
    cluster: parseStringParam(params.cluster, (simpleUrl ? "" : "~")),
  };
};

export default useReqContext;
